(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jump-tos"] && !Shopify.designMode) return;
  try {
    
    function animate(elem, style, unit, from, to, time, prop) {
      if (!elem) {
        return;
      }
      var start = new Date().getTime(),
        timer = setInterval(function() {
          var step = Math.min(1, (new Date().getTime() - start) / time);
          if (prop) {
            elem[style] = (from + step * (to - from)) + unit;
          } else {
            elem.style[style] = (from + step * (to - from)) + unit;
          }
          if (step === 1) {
            clearInterval(timer);
          }
        }, 25); 
      if (prop) {
        elem[style] = from + unit;
      } else {
        elem.style[style] = from + unit; 
      } 
    }


	let jumpto_buttons = document.querySelectorAll(".js-jumpto-btn");  
  
    jumpto_buttons.forEach(cur => {
      const jumpto_target = cur.getAttribute('data-target');
      const target_el = document.querySelector(jumpto_target);  

      cur.addEventListener("click", () => {
        console.log(target_el);

      	animate(document.scrollingElement || document.documentElement, "scrollTop", "", 0, target_el.offsetTop, 500, true);
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    

if(document.querySelector(".template-product")) {
    var tabMobile = document.querySelectorAll(".product-page-tabs--mobile .product-page-nav-link");
    var tabInitial = document.querySelector(".product-page-tabs--mobile .product-page-tab-content.initial");

    // if(tabInitial) {
    //     tabInitial.style.maxHeight = tabInitial.scrollHeight + "px";
    //     tabInitial.classList.remove('initial');
    // }

    tabMobile.forEach(curNav => {
        curNav.addEventListener('click', () => {
            const tabNav = curNav;
            const tabContent = curNav.parentNode.querySelector('.product-page-tab-content');

            tabNav.classList.toggle('active');

            if (tabContent.style.maxHeight) {
                tabContent.style.maxHeight = null;
            } else {
                tabContent.style.maxHeight = tabContent.scrollHeight + "px";
            }
        });
    });

    const desktopNav = (() => {
        const tabNavsDesktop = document.querySelectorAll(".product-page-tabs--desktop .product-page-nav-link");
        const tabsDesktop = document.querySelectorAll('.product-page-tabs--desktop .product-page-tab');
        const btnPrev = document.querySelector(".product-page-nav-prev");
        const btnNext = document.querySelector(".product-page-nav-next");

        const hideAllEl = (el) => {
            el.forEach(curEl => {
                curEl.classList.remove('active');
            });
        };
        const hideEl = (el) => {
            el.classList.remove('active');
        };
        const showEl = (el) => {
            el.classList.add('active');
        };

        // Event-Listener für jeden Tab-Link hinzufügen
        tabNavsDesktop.forEach((curNav, index) => {
            curNav.addEventListener('click', () => {
        
                hideAllEl(tabNavsDesktop);
                showEl(curNav);
        
                tabsDesktop.forEach((curTab, indexContent) => {
                    if(index == indexContent) {
                        showEl(curTab);
                    } else {
                        hideEl(curTab);
                    }
                });
            });
        });

        // Event-Listener für prev-Button hinzufügen
        btnPrev.addEventListener('click', () => {
        
            const tabNavsArray = Array.from(tabNavsDesktop);
            const tabsArray = Array.from(tabsDesktop);
            const tabActive = tabNavsDesktop[1].parentNode.querySelector('.active');
            const tabActiveNum = tabNavsArray.indexOf(tabActive);
            
            const prevTabNav = (tabActiveNum > 0) 
                                ? tabNavsArray.find((cur, index) => index == (tabActiveNum - 1)) 
                                : tabNavsArray.find((cur, index) => index == (tabNavsArray.length - 1));
            const prevTab = (tabActiveNum > 0) 
                            ? tabsArray.find((cur, index) => index == (tabActiveNum - 1)) 
                            : tabsArray.find((cur, index) => index == (tabsArray.length - 1));

            hideAllEl(tabNavsDesktop);
            showEl(prevTabNav);

            hideAllEl(tabsDesktop);
            showEl(prevTab);
        });

        // Event-Listener für next-Button hinzufügen
        btnNext.addEventListener('click', () => {
        
            const tabNavsArray = Array.from(tabNavsDesktop);
            const tabsArray = Array.from(tabsDesktop);
            const tabActive = tabNavsDesktop[1].parentNode.querySelector('.active');
            const tabActiveNum = tabNavsArray.indexOf(tabActive);

            const nextTabNav = (tabActiveNum < (tabNavsArray.length - 1)) 
                                ? tabNavsArray.find((cur, index) => index == (tabActiveNum + 1)) 
                                : tabNavsArray.find((cur, index) => index == 0);
            const nextTab = (tabActiveNum < (tabNavsArray.length - 1)) 
                            ? tabsArray.find((cur, index) => index == (tabActiveNum + 1)) 
                            : tabsArray.find((cur, index) => index == 0);

            hideAllEl(tabNavsDesktop);
            showEl(nextTabNav);

            hideAllEl(tabsDesktop);
            showEl(nextTab);
        });
    })();
};

const personaNav = (() => {
   const navItems = document.querySelectorAll('.product-page-tab-personas--mobile .product-page-tab-personas__nav-item');
   const navContents = document.querySelectorAll('.product-page-tab-personas--mobile .product-page-tab-personas__persona')

   navItems.forEach((cur, index) => {
       cur.addEventListener('click', () => {

           navItems.forEach(curItem => {
               curItem.classList.remove('active');
           });
           cur.classList.add('active');

           navContents.forEach((curContent, indexContent) => {
               if(index == indexContent) {
                   curContent.classList.add('active');
               } else {
                   curContent.classList.remove('active');
               }
           });
       });
   });
})();


  } catch(e) { console.error(e); }
})();
})();
